<script context="module" lang="ts">
    import { writable } from "svelte/store"

    type TGroupsData = {
      lastActive: symbol,
      currActive: symbol
    }

    type TGroups = Record<string, TGroupsData>

    // save by the groups which item is active
    const groups = writable<TGroups>({})
  </script>

  <script lang="ts">
    import { slide } from "svelte/transition"

    /**
     * Set the collapsible as opened (use bind to not force be always opened).
     * Set only one per group as expanded.
    */
    export let expanded = false

    /**
     * Set a name to allow the sync collapsible close.
     * Set to null or leave empty to not allow syncing the items
     */
    export let group: string|null = null

    export let title: string = " "

    const id = Symbol("my-id")

    function toggleCollapse() {
      expanded = !expanded;

      // if oppening, close all the rest
      if (expanded && group) {
        ($groups as TGroups)[group] = {
          lastActive: ($groups as TGroups)[group]?.currActive,
          currActive: id,
        };
      } else {
        ($groups as TGroups)[group] = {
          lastActive: id,
          currActive: null,
        };
      }
    }

    // if the last active is me, close me
    $: if (group && ($groups as TGroups)[group]?.lastActive === id) {
      expanded = false
    }
  </script>

  <div class="container">
    <header on:click={ toggleCollapse }>
      <span>{ title }</span>
      <span class="icon">
        {#if expanded}
          -
        {:else}
          +
        {/if}
      </span>
    </header>
    {#if expanded}
      <div class="content" transition:slide={{ duration: 250 }}>
        <!-- the collapsible content -->
        <slot></slot>
      </div>
    {/if}
  </div>

  <style lang="scss">
    .container {
      --padding: 1rem;
      --max-height: 700px;

      background-color: white;
      overflow: hidden;
      border-radius: 1.25rem;
      //margin: .6rem 0;
      position: relative;
      z-index: 10;

      &:not(:first-child) {
        margin-top: 1.5rem;
      }

      header {
        padding: var(--padding);
        font-size: 1.5rem;
        font-weight: 700;
        color: #3A1870;
        cursor: pointer;
        position: relative;
        display: flex;
        justify-content: space-between;
      }

      .content {
        padding: var(--padding);
        background-color: #fff;
        border-radius: 0.75rem;
        font-size: 1.28rem;
      }
    }
  </style>
